import {ALL} from './directives'
import {Features} from "./api";
import {Reactivity} from "./reactivity";

export const Utility = {

    /**
     * Will validate the options passed to it
     * @param configuration
     */
    validateAppOptions: (configuration) => {
        const status = {error: false, message: ''};

        // validate (routes)
        if (configuration.routes === undefined) {
            status.error = true;
            status.message = 'Your app options does not contain any routes';
        }

        // validate (visualErrors)
        if (configuration.visualErrors === undefined) {
            status.error = true;
            status.message = 'Your app options does not contain the property visualErrors';
        }

        // validate (renderEl)
        if (configuration.renderEl === undefined) {
            status.error = true;
            status.message = 'Your app options does not contain the property renderEl';
        }

        if (!status.error) {
            return true;
        }
        else {
            console.error(`Create App Error :: ${status.message}`);
            return false;
        }
    },

    /**
     * Builds the system environment variables
     * @param {{renderEl: String, routes: Array, visualErrors: Boolean}} configuration
     */
    setEnvironment: (configuration) => {
        window.$ActiveJS = {
            initialRenderFinished: false,
            pageNotFound: false,
            DOMBindings: [],
            DOMBoundKeys: [],
            DOMAnimations: [],
            DOMEvents: [],
            Libraries: {},
            PassedProps: {},
            renderEl: configuration.renderEl.replace(/#/g, ''),
            visualErrors: configuration.visualErrors,
        };
    },

    loadAppStyles: () => {},

    logAppInfo: () => {},

    /**
     * Will check if a value is nested based off a string dot notation
     * @param value
     * @returns {boolean}
     */
    isNestedProperty: (value) => {
        if (value.indexOf('.') > -1) return true;
    },

    /**
     * Will choose to display an element or hide it
     * @param {Boolean} value
     * @param element
     * @param {Object} Binding
     */
    toggleElement: (value, element, Binding) => {
        // define index
        let index;
        if (value) {
            Binding.elementParent.insertBefore(element, Binding.elementParent.children[Binding.elementIndex]);
        }
        else {
            element.remove();
        }
    },

    /**
     * Will insert a a text node at the cursor position
     * @param text
     */
    insertTextAtCursor: (text) => {
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        range.deleteContents();
        let node = document.createTextNode(text);
        range.insertNode(node);
        selection.collapseToEnd();

        // for(let position = 0; position != text.length; position++)
        // {
        //     selection.modify("move", "right", "character");
        // };
    },

    /**
     * Converts a string into a valid document object
     * @param string
     * @returns {Document}
     */
    convertTextToDocument: (string) => {
        const parser = new DOMParser();
        return parser.parseFromString(string, 'text/html');
    },

    /**
     *
     * @param {Number} length
     * @param {String} CASE
     * @returns {string}
     */
    getRandomString: (length, CASE) => {
        let result = '';
        let characters = '';
        if (CASE != false) {
            switch (CASE) {
                case "UPPERCASE":
                    characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
                    break;
                case "LOWERCASE":
                    characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
                    break;
            }
        }
        else {
            characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        }

        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    },

    /**
     *
     * @param VM
     * @param bindingString
     * @returns {*}
     */
    getNestedProperty: (VM, bindingString) => {

        let schema = VM;  // a moving reference to internal objects within obj
        let pList = bindingString.replace(' ', '').split('.');
        let len = pList.length;
        for (let i = 0; i < len - 1; i++) {
            let elem = pList[i];
            // if (!schema[elem]) schema[elem] = {}
            schema = schema[elem];
        }

        if (schema[pList[len - 1]] !== undefined) {
            return schema[pList[len - 1]];
        }
        else {
            return schema[pList[len - 1]];
        }
    },

    /**
     * Sets a nested property in the VM
     * @param {Object} VM
     * @param {String} bindingString
     * @param {String} updateValue
     */
    setNestedProperty: (VM, bindingString, updateValue) => {
        let schema = VM;  // a moving reference to internal objects within obj
        let pList = bindingString.split('.');
        let len = pList.length;
        for (let i = 0; i < len - 1; i++) {
            let elem = pList[i];
            if (!schema[elem]) schema[elem] = {}
            schema = schema[elem];
        }

        const value = schema[pList[len - 1]];

        if (schema[pList[len - 1]] !== undefined) {
            schema[pList[len - 1]] = updateValue;
        }
    },

    setIsDefProperty: () => {

    },

    /**
     * Looks through the params passed and checks if they are in the VM or static
     * @param {Array} unFormattedParams
     */
    formatFunctionParams: (unFormattedParams) => {
        const builtParams = [];
        unFormattedParams.forEach(param => {
            // if param is a VM property
            let value
            if (param.indexOf('this') === -1) {
                value = Utility.getNestedProperty(Features.VM, param);
            }

            const checkForNumbers = (data, isVMProp) => {
                if (isNaN(Number(data))) {
                    builtParams.push({
                        isVMProp,
                        value: data,
                        original: param
                    });

                }
                else {
                    builtParams.push({
                        isVMProp,
                        value: data,
                        original: param
                    });
                }
            };

            // check if a value from the VM was retrieved
            if (value !== undefined) {
                checkForNumbers(value, true);
            }
            else {
                checkForNumbers(param, false);
            }

        });

        return builtParams;
    },

    /**
     * Parses through a param value and decides how to interpret it
     * @param param
     * @returns {Object|number|*}
     */
    parseFunctionParams: (param) => {
        let isNumber = false;
        if (!isNaN(Number(param.value))) isNumber = true;

        // if it is a number convert from string
        if (isNumber) return Number(param.value);
        else {
            if (param.value.indexOf('{') !== -1) {
                return Utility.buildObjectFromString(param);
            }
            else return param.value;
        }
    },

    /**
     * Will build up an object based off of a string
     * @param param
     * @returns {Object}
     */
    buildObjectFromString: (param) => {
        const BuiltObject = {};
        const raw = param.value.replace(/{/g, '').replace(/}/g, '').split(',');
        raw.forEach(pair => {
            const raw = pair.split(":");
            let retrievedValue = Utility.getNestedProperty(Features.VM,  raw[1].replace(/ /g, ''));

            if (retrievedValue !== undefined) {
                if (retrievedValue.isDef) BuiltObject[raw[0].replace(/ /g, '')] = retrievedValue.value;
                else BuiltObject[raw[0].replace(/ /g, '')] = retrievedValue;
            }
            else {
                BuiltObject[raw[0].replace(/ /g, '')] = Utility.parseFunctionParams({value: raw[1]});
            }
        })
        return BuiltObject;
    },

    isObject: (item) => (typeof item === "object" && !Array.isArray(item) && item !== null),

    getDefault404HTML: () => {
        return `
        <script>
            Expose("404", {});
        </script>
        
        <template>
            <div id="screen">
                <div id="screenWrapper">
                    <div class="header">
                        <div class="dotsWrapper">
                            <div class="dot first"></div>
                            <div class="dot second"></div>
                            <div class="dot third"></div>
                        </div>
                    </div>
                    <div class="content">
                        404 Page Not Found
                    </div>
                </div>
            </div>
        </template>

        <style>
            * {
                padding: 0;
                margin: 0;
                box-sizing: border-box;
            }
            #screen {
                width: 100vw;
                height: 100vh;
                font-family: Arial;
                background-color: #dadada;
                display: flex;
                align-items: center;
                justify-content: space-around;
            }
            #screenWrapper {
                width: 60%;
                height: 80%;
                border: solid 5px #303030;
                border-radius: 15px;
                display: flex;
                flex-direction: column;
            }
            #screenWrapper .header {
                height: 15%;
                border-bottom: solid 5px #303030;
                background-color: #ffffff;
                border-radius: 10px 10px 0 0;
                display: flex;
                align-items: center;
                justify-items: start;
            }
            #screenWrapper .header .dotsWrapper {
                width: 15%;
                margin: 0 5%;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            #screenWrapper .header .dotsWrapper .dot {
                width: 20px;
                height: 20px;
                border-radius: 50%;
            }
            #screenWrapper .header .dotsWrapper .dot.first {
                background-color: #303030;
            }
            #screenWrapper .header .dotsWrapper .dot.second {
                background-color: #303030;
            }
            #screenWrapper .header .dotsWrapper .dot.third {
                background-color: #303030;
            }
            #screenWrapper .content {
                color: #161616;
                height: 85%;
                font-size: 50px;
                font-weight: bolder;
                border-radius: 0 0 10px 10px;
                background-color: #c94a4a;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        </style>`;
    },

    isBaseURL: () => {
        return window.location.pathname === '/' && window.location.hash === "";
    },

    replaceDynamicValues: (Binding, Value) => {
        if (Binding.containsMultiBindings) {
            let newHTML = "";
            Binding.elementBindings.forEach(value => {

                const rgx = new RegExp('{'+value+'}', "g");
                if (newHTML === "") {
                    newHTML = Binding.rawHTML.replace(rgx, Value);
                }
                else {
                    newHTML = newHTML.replace(rgx, Value);
                }
            });

            Binding.elementReference.innerHTML = newHTML;
        }
        else {
            const rgx = new RegExp('{'+Binding.elementBinding+'}', "g");
            Binding.elementReference.innerHTML = Binding.rawHTML.replace(rgx, Value);
        }
    },

    /**
     * Will get the DOM Binding needing to be updated
     * @param {{template: Document, loadedVM: Object, propertyToUpdate: false|String, isDef: false }} options
     * @returns {Array}
     */
    getDOMBindingNeedingUpdate: (options) => {
        let Bindings = [];
        $ActiveJS.DOMBindings.forEach(DOMBinding => {
            let elementBindingToUpdate;
            if (DOMBinding.elementBinding.indexOf('#') === -1 && !DOMBinding.containsMultiBindings) {
                elementBindingToUpdate = DOMBinding.elementBinding.split('.');
                if (elementBindingToUpdate[elementBindingToUpdate.length - 1] === options.propertyToUpdate) Bindings.push(DOMBinding);
            }
            else {
                // handle if expressions
                if (DOMBinding.elementBinding.indexOf(options.propertyToUpdate) !== -1) Bindings.push(DOMBinding);
                else if (DOMBinding.containsMultiBindings) DOMBinding.elementBindings.forEach(Binding => {if (Binding.bindingName.indexOf(options.propertyToUpdate) !== -1) Bindings.push(DOMBinding)});
            }
        });

        return Bindings;
    },

};